import React from 'react';
import {
  Box,
  Container,
  Heading,
  SimpleGrid,
  VStack,
  Image,
  Text,
  useColorMode,
} from '@chakra-ui/react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const MotionBox = motion(Box);

const Categories = () => {
  const { colorMode } = useColorMode();

  // Mock data for categories
  const categories = [
    {
      id: 1,
      name: 'پاپ',
      image: 'https://picsum.photos/300',
      songCount: 150,
    },
    {
      id: 2,
      name: 'راک',
      image: 'https://picsum.photos/301',
      songCount: 120,
    },
    {
      id: 3,
      name: 'کلاسیک',
      image: 'https://picsum.photos/302',
      songCount: 80,
    },
    {
      id: 4,
      name: 'جاز',
      image: 'https://picsum.photos/303',
      songCount: 60,
    },
    {
      id: 5,
      name: 'هیپ هاپ',
      image: 'https://picsum.photos/304',
      songCount: 90,
    },
    {
      id: 6,
      name: 'الکترونیک',
      image: 'https://picsum.photos/305',
      songCount: 70,
    },
  ];

  return (
    <Container maxW="container.xl" py={8}>
      <VStack spacing={8} align="stretch">
        <Heading size="xl">دسته‌بندی‌ها</Heading>
        <SimpleGrid columns={{ base: 1, sm: 2, md: 3 }} spacing={6}>
          {categories.map((category, index) => (
            <Link key={category.id} to={`/category/${category.id}`}>
              <MotionBox
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3, delay: index * 0.1 }}
              >
                <Box
                  bg={colorMode === 'dark' ? 'gray.700' : 'white'}
                  borderRadius="xl"
                  overflow="hidden"
                  boxShadow="lg"
                  position="relative"
                  _hover={{ transform: 'translateY(-4px)' }}
                  transition="transform 0.2s"
                >
                  <Image
                    src={category.image}
                    alt={category.name}
                    w="100%"
                    h="200px"
                    objectFit="cover"
                  />
                  <Box
                    position="absolute"
                    bottom={0}
                    left={0}
                    right={0}
                    bg="rgba(0, 0, 0, 0.7)"
                    p={4}
                  >
                    <Text color="white" fontWeight="bold" fontSize="xl">
                      {category.name}
                    </Text>
                    <Text color="gray.300">
                      {category.songCount} آهنگ
                    </Text>
                  </Box>
                </Box>
              </MotionBox>
            </Link>
          ))}
        </SimpleGrid>
      </VStack>
    </Container>
  );
};

export default Categories; 